import React, { useContext } from "react";

import { RedirectReceiptPageContext } from "./RedirectReceiptPageProvider";

import Layout from "../Layout";
import * as UI from "./ui";

const Failure = () => {
  const { paymentIntent } = useContext(RedirectReceiptPageContext);

  return (
    <Layout.FullWidth fold id="receipt">
      <Layout.FullWidthColumn>
        <UI.Heading>We're sorry but your payment failed</UI.Heading>
        {paymentIntent.last_payment_error?.type === "card_error" ? (
          <UI.Message>
            We encountered the following error processing your payment:
            {paymentIntent.last_payment_error.message}
          </UI.Message>
        ) : (
          <UI.Message>
            An error was encountered processing your payment method and no charge was processed.
          </UI.Message>
        )}
        <UI.Message>
          Please try again and, if the problem persists, you can check in with your card issuer or bank to determine why the payment has failed.
          For any questions you may contact, <a href="mailto:support@tapkat.com">support@tapkat.com</a>.
        </UI.Message>
      </Layout.FullWidthColumn>
    </Layout.FullWidth>
  );
};

export default Failure;
